import { Acknowledgment, AcknowledgmentResource } from 'types/Acknowledgment';

const isSameAcknowledgment = (
  acknowledgment: Acknowledgment,
  resourceType: AcknowledgmentResource,
  resourceId: string,
  tinyAccountId: string,
  kitId: string | null,
) =>
  acknowledgment.resource_type === resourceType &&
  acknowledgment.resource_id === resourceId &&
  acknowledgment.tinyaccount_id === tinyAccountId &&
  acknowledgment.kit_id === kitId;

export const findAcknowledgment = (
  acknowledgments: Acknowledgment[],
  resourceType: AcknowledgmentResource,
  resourceId: string,
  tinyAccountId: string,
  kitId: string,
) =>
  acknowledgments.find(acknowledgment =>
    isSameAcknowledgment(
      acknowledgment,
      resourceType,
      resourceId,
      tinyAccountId,
      kitId,
    ),
  );

// the server keeps one row per (tinyaccount_id, resource_type, resource_id,
// kit_id)
export const upsertAcknowledgment = (
  acknowledgments: Acknowledgment[],
  acknowledgment: Acknowledgment,
): Acknowledgment[] => [
  ...acknowledgments.filter(
    existing =>
      !isSameAcknowledgment(
        existing,
        acknowledgment.resource_type,
        acknowledgment.resource_id,
        acknowledgment.tinyaccount_id,
        acknowledgment.kit_id,
      ),
  ),
  acknowledgment,
];
